var SaitoInputControls = require('./saito-input-controls.template');
var SaitoInputContacts = require('./saito-input-contacts.template');
module.exports = function (input_self) {
  //
  //We are hardcoding knowledge about what the saito-input-selection-box dimensions are
  //to keep it from going off the screen
  //
  var position = {};
  var reference;

  // Chat box embedded
  if (input_self.display == 'small' || input_self.display == 'medium') {
    var si = document.querySelector("".concat(input_self.container, " .saito-input"));
    reference = si.getBoundingClientRect();
    position.top = reference.top;
    position.left = reference.right - 359;
    if (input_self.display == 'small') {
      position.left += 35;
    }
  } else {
    // RS Post overlay

    var _si = document.querySelector("".concat(input_self.container, " .saito-input .selection-box-tabs"));
    reference = _si.getBoundingClientRect();
    position.top = reference.top;
    position.left = reference.right;
  }
  var top = position.top;
  var bottom = window.innerHeight - top;
  var left = position.left;
  if (left + 360 > window.innerWidth) {
    left = window.innerWidth - 360;
  }

  // RS - mobile correction
  if (input_self.display === 'large' && window.innerWidth < 600) {
    console.warn('Readjusting for mobile display!');
    bottom = 0;
    top = window.innerHeight - reference.bottom;
  }
  var html = "\n  <div id=\"saito-input-selection-box\" class=\"saito-input-selection-box\" style=\"bottom:".concat(bottom, "px; left:").concat(left, "px; max-height:").concat(top, "px;\">\n    <div class=\"selection-box-window\">\n      <div class=\"selection-box-pane ").concat(!input_self.open_tab || input_self.open_tab == 'emoji-window' ? 'active-tab' : '', "\" id=\"emoji-window\"></div>\n      <div class=\"selection-box-pane photo-window ").concat(input_self.open_tab == 'photo-window' ? 'active-tab' : '', "\" id=\"photo-window\">drag and drop an image or click to select one to upload</div>\n      <div class=\"selection-box-pane ").concat(input_self.open_tab == 'gif-window' ? 'active-tab' : '', "\" id=\"gif-window\"></div></div>");
  if (input_self.display !== 'large') {
    html += SaitoInputControls(input_self);
  }
  html += '</div>';
  return html;
};

//<emoji-picker></emoji-picker>